<script setup lang="ts">
import type { PropType } from "vue";
import Slider from "@vueform/slider";
import { ref, computed } from "vue";
import FloatingLabelInput from "@/components/FloatingLabelInput/FloatingLabelInput.vue";

const props = defineProps({
    label: {
        type: String,
        default: "",
    },
    name: {
        type: String,
        default: "",
    },
    currentValue: {
        type: Array as PropType<number[]>,
        required: true,
        default: () => [110, 5000],
    },
    range: {
        type: Array as PropType<number[]>,
        required: true,
        default: () => [110, 5000],
    },
    prefix: {
        type: String,
        default: "",
    },
    postSuffix: {
        type: String,
    },
    rangeLabelMin: {
        type: String,
        required: true,
    },
    rangeLabelMax: {
        type: String,
        required: true,
    },
});

const values = ref(props.currentValue);
const maxValueIsCollected = computed(() => {
    return values.value[1].toString() === props.range[1].toString();
});
const isFilled = computed(() => {
    return props.range.toString() !== values.value.toString();
});
</script>
<template>
    <div class="[ c-range-input ]">
        <div
            class="[ c-range-input__headline ]"
            :class="{ 'is-active': isFilled }"
        ></div>
        <Slider
            v-model="values"
            class="[ c-range-input__slider ]"
            :lazy="false"
            :tooltips="false"
            :showTooltip="'drag'"
            :min="range[0]"
            :max="range[1]"
            @change="$emit('changeRangeInput', values)"
        />
        <div class="[ c-range-input__container ]">
            <div class="[ c-range-input__container-left ]">
                <floating-label-input
                    :prefix="prefix"
                    :has-suffix="false"
                    name="min"
                    v-model:value="values[0]"
                    :label="rangeLabelMin"
                    :post-suffix="postSuffix"
                    @change="$emit('changeRangeInput', values)"
                />
            </div>
            <div class="[ c-range-input__container-right ]">
                <floating-label-input
                    :prefix="prefix"
                    :has-suffix="maxValueIsCollected"
                    name="max"
                    v-model:value="values[1]"
                    :label="rangeLabelMax"
                    suffix="&plus;"
                    :post-suffix="postSuffix"
                    @change="$emit('changeRangeInput', values)"
                />
            </div>
        </div>
    </div>
</template>
